// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_-N-DA","logo":"index_logo_LkjJS","breadcrumbs":"index_breadcrumbs_nR2se"};